import EditAttributeIO from './EditAttributeIO'

export default EditAttributeIO
